import { render } from "./App.vue?vue&type=template&id=7f33b1ae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7f33b1ae&lang=css"

import exportComponent from "/Users/drusha/Desktop/drusha computer/drusha-computer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__